/** JP label figures. Plain functions (no React) so the export gather can use
 *  them in the browser and in the export worker alike. */

/** A figure placeholder looks like 【図:fig1.gif】 — capture the gfname. */
export const FIG_RE = /【図:([^】]+)】/g;

/** Replace each 【図:gfname】 placeholder with a real <img> (public GCS
 *  URL) or, if missing, a small labelled fallback — never blank. Exported so the
 *  Compare snapshot builder can inject the same figures into its JP blocks. */
export function injectFigures(html: string, urls: Record<string, string>): string {
  return html.replace(FIG_RE, (_m, gf: string) => {
    const url = urls[gf];
    if (!url) return `<span class="jp-fig-missing">［図: ${gf}］</span>`;
    return `<figure class="jp-figure"><img src="${url}" alt="${gf}" loading="lazy" /></figure>`;
  });
}
